<template>
  <button
    v-if="isSupported"
    @click="toggleFullscreen"
    :class="[
      'fullscreen-toggle',
      'fixed',
      'top-4',
      'right-4',
      'z-50',
      'p-3',
      'rounded-full',
      'shadow-lg',
      'hover:shadow-xl',
      'transition-all',
      'duration-200',
      'border',
      'focus:outline-none',
      'focus:ring-2',
      'focus:ring-blue-500',
      'focus:ring-offset-2',
      'touch-action-manipulation',
      isFullscreen 
        ? 'bg-blue-500/90 hover:bg-blue-600 text-white border-blue-400' 
        : 'bg-white/90 hover:bg-white text-gray-700 border-gray-200 hover:border-gray-300'
    ]"
    :title="isFullscreen ? 'Exit Fullscreen (ESC)' : 'Enter Fullscreen'"
    aria-label="Toggle fullscreen mode"
  >
    <svg
      v-if="!isFullscreen"
      class="w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
      />
    </svg>
    <svg
      v-else
      class="w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 9V4.5M9 9H4.5M9 9L3.5 3.5M15 9h4.5M15 9V4.5M15 9l5.5-5.5M9 15v4.5M9 15H4.5M9 15l-5.5 5.5M15 15h4.5M15 15v4.5m0-4.5l5.5 5.5"
      />
    </svg>
  </button>
</template>

<script setup lang="ts">
import { useFullscreen } from '@/composables/useFullscreen';

const { isFullscreen, isSupported, toggleFullscreen } = useFullscreen();
</script>

<style scoped>
.fullscreen-toggle {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* Hide on mobile devices */
@media (max-width: 768px) {
  .fullscreen-toggle {
    display: none;
  }
}

/* Ensure button is always visible in fullscreen */
.fullscreen-toggle:fullscreen {
  position: fixed !important;
  top: 1rem !important;
  right: 1rem !important;
}
</style>
